export default {
  title: "Pošljite povpraševanje",
  para: "Sporočite nam svoje želje o storitvah, ki vas zanimajo. Odgovorili  vam bomo v najkrajšem času.",
  errorMessage: {
    title: "Napaka",
    message: "Nekje se je zalomilo, poskusite znova.",
  },
  successMessage: {
    title: "Poslano",
    message: "Sporočilo je bilo uspešno poslano!",
  },
  buttonSubmit: "Pošljite",
  fullname: "Ime in priimek",
  email: "Elektronski naslov",
  company: "Podjetje",
  yourMsg: "Vaše sporočilo",
  terms: "Strinjam se s pogoji",
  dialogClose: "Zapri",
};

